import { USER_TYPES } from '../../config/app.config';

const staffColumns = [
  {
    key: 'fullName',
    name: 'Name',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'staff-name-column',
    transform: (fullName, row) => {
      const first = String(row?.firstName || '').trim();
      const last = String(row?.lastName || '').trim();
      if (first && last) return `${last}, ${first}`;
      if (last) return last;
      if (first) return first;
      const cleaned = String(fullName || '')
        .replace(/^,\s*/, '')
        .replace(/,\s*$/, '')
        .trim();
      if (cleaned) return cleaned;
      return row?.username || '—';
    },
  },
  {
    key: 'designation',
    name: 'Designation',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'staff-designation-column',
  },
  {
    key: 'type',
    name: 'Permissions',
    sortable: false,
    transform: (type) => {
      if (type === USER_TYPES.ADMIN) return 'Admin';
      if (type === USER_TYPES.IPAD_ONLY) return 'iPad Only';
      return 'User';
    },
    filterable: false,
    capitalize: true,
    className: 'staff-permissions-column',
  },
  {
    key: 'emailPhone',
    name: 'Email Address',
    sortable: false,
    filterable: false,
    className: 'staff-email-column',
  },
  {
    key: 'username',
    name: 'Username',
    sortable: false,
    filterable: false,
    className: 'staff-username-column',
  },
  {
    key: 'privateCredentials',
    name: 'Credentials',
    transform: (privateCredentials) =>
      privateCredentials ? 'Private' : 'Assigned',
    sortable: false,
    filterable: false,
    className: 'staff-credentials-column',
  },
  {
    key: 'status',
    name: 'Status',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'staff-status-column',
  },
];

export const facilityColumn = {
  key: 'facilityDisplayName',
  name: 'Facility',
  sortable: false,
  filterable: false,
  capitalize: true,
  className: 'staff-facility-column',
};

export default staffColumns;
